import { BasicRequest } from "./basicRequest";

export class UploadFileRequest extends BasicRequest{

    public addHeaderIfMissing:boolean = false;
    public externalUpload:boolean = false; //used to indicate external upload
    public moovConfigurationId?:number; //used for external file upload
    public externalUploaderName?:string; //used for external file upload
    public externalUploaderEmail?:string; //used for external file upload

    constructor(){
        super();
    }
}